import { useEffect } from 'react';

import {
	useRouteDataRef,
	useRouteActions,
} from '@confluence/route-manager/entry-points/RouteState.ts';
import {
	useSetOnboardingState,
	useGetOnboardingState,
	deserializeState,
} from '@confluence/onboarding-helpers/entry-points/hooks/useOnboardingState.ts';
import { HAS_SEEN_AUTO_SHOW_ANALYTICS } from '@confluence/onboarding-helpers/entry-points/constants/onboarding-state-constants.ts';
import { fg } from '@confluence/feature-gating';

export const useShowAnalyticsParam = (setPopupOpen: (open: boolean) => void) => {
	const { setOnboardingState } = useSetOnboardingState();
	const { data: onboardingStateData, loading: onboardingStateLoading } = useGetOnboardingState(
		HAS_SEEN_AUTO_SHOW_ANALYTICS,
		!fg('cc_first_ever_view_email_analytics_kill_switch'),
	);

	const routeDataRef = useRouteDataRef();
	const { setQueryParams } = useRouteActions();

	useEffect(() => {
		if (!fg('cc_first_ever_view_email_analytics_kill_switch') || onboardingStateLoading) {
			return;
		}

		if (routeDataRef.current?.queryParams['showAnalytics'] === 'true') {
			setQueryParams({ showAnalytics: undefined }, true);

			const { hasSeenAutoShowAnalytics } = deserializeState(onboardingStateData);

			if (!hasSeenAutoShowAnalytics) {
				setPopupOpen(true);
				setOnboardingState({
					key: HAS_SEEN_AUTO_SHOW_ANALYTICS,
					value: 'true',
				});
			}
		}
	}, [
		routeDataRef,
		setQueryParams,
		onboardingStateLoading,
		onboardingStateData,
		setOnboardingState,
		setPopupOpen,
	]);
};
